<template>
    <div class="sustainable-component pot-base-salary">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-base-salary</div>-->
        <div class="container-fluid p-0">
            <div class="row" v-if="calculationType == '1'">
                <div class="col-12 col-md-8 pt-5">
                    <div class="card px-3 py-5 rounded common-label-container">
                        <div class="common-label-tab-container rounded">
                            <div class="px-3 pt-1 rounded tab-contained" style="background-color:white">Konstruktion</div>
                        </div>
                        <div>
                            <!-- content -->
                            <v-form v-model="valid" ref="form">
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="table-scrollable-container">
                                                <table class="table table-light table-hover table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th class="col-2">Poäng fr.o.m.</th>
                                                            <th class="col-2">Poäng t.o.m.</th>
                                                            <th class="col-4">Grundlön kr</th>
                                                            <th class="col-4">Ny grundlön</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(interval, index) in salaryIntervals" :key="index">
                                                            <td>{{interval.From}}</td>
                                                            <td>{{interval.To}}</td>
                                                            <td><span v-decimal-text.max2="interval.Salary"></span></td>
                                                            <td>
                                                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" :rules="[rules.float]" label="Grundlön per poäng" v-model="interval.PotSalary" variant="outlined" hide-details="true" density="compact"></v-text-field>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setPotSalariesWithIntervalValue">
                                                Spara
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                            <!-- end content -->
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-5">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="GLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="GLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-5" v-if="calculationType == '2'">
                <div class="col-12 col-md-8">
                    <CommonLabelContainer title="Konstruktion">
                        <v-form v-model="valid" ref="form2">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6 mr-3">
                                        <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" :rules="[rules.float]" label="Grundlön per poäng" v-model="potSalaryPerPoints" variant="outlined"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6 mr-3">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setPotSalariesWithPointValue">
                                            Spara
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="GLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="GLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><b>Utfall</b></div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-8">
                    <table class="table table-light table-hover table-striped">
                        <thead>
                            <tr>
                                <th class="col-4">Befattning</th>
                                <th class="col-2">Poäng</th>
                                <th class="col-3">Grundlön kr</th>
                                <th class="col-3">Ny grundlön kr</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(position, index) in positions" :key="index">
                                <td>{{position.Name}}</td>
                                <td>{{position.Points}}</td>
                                <td><span v-decimal-text.max2="position.BaseSalary"></span></td>
                                <td v-if="calculationType == '0'">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="position.PotBaseSalary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                </td>
                                <td v-else><span v-decimal-text.max2="position.PotBaseSalary"></span></td>
                            </tr>
                        </tbody>
                    </table>
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary mt-3" @click="setAllPotSalaries" v-if="calculationType == '0'">
                        Spara
                    </v-btn>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-0" v-if="calculationType == '0'">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="GLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="GLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-0" v-if="calculationType == '3'">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="BLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="BLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>

        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <WagePotSalaryInterval v-bind:disabled="disabled" :model="model" ref="updatePotSalaryInterval" @updated="updateAfterChange"></WagePotSalaryInterval>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'
    import CommonLabelContainer from "../../common/common-label-container";
    import WagePotSalaryInterval from '../wagesetting/update/update-pot-salary-interval.vue'
    import { ref } from 'vue'

    const updatePotSalaryInterval = ref(null);
    const form = ref(null);
    const form2 = ref(null);

    export default {
        emits: ['updated'],
        name: 'pot-base-salary',
        components: {
            CommonLabelContainer,
            WagePotSalaryInterval,
            CommonSpinner,
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async setPotSalariesWithPointValue() {
                var result = await this.form2.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await WageService.updateBasePotWagepart(false, this.calculationType, this.potBaseSalary, this.potSalaryPerPoints)
                    this.updateAfterChange();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async setPotSalariesWithIntervalValue() {
                this.loading++;
                try {
                    await WageService.updatePotSalaries(this.salaryIntervals);
                    this.updateAfterChange();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async setAllPotSalaries() {
                this.loading++;
                try {
                    await WageService.UpdatePotBaseSalaries(this.positions);
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            updateInterval(item) {
                this.loading++;
                this.updatePotSalaryInterval.open(item);
                this.loading--;
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateBasePotWagepart(false, this.calculationType, this.potBaseSalary, this.potSalaryPerPoints);
                    if (this.calculationType == '1') {
                        this.loadIntervals();
                    }

                    this.loadPotDistribution();
                    this.getSalaryPart();
                    this.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    this.salaryIntervals = await WageService.getSalaryInterval(0);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartBase();
                    this.potSalaryPerPoints = salaryPart.PotSalaryPerPoints;
                    this.calculationType = salaryPart.CalculationType.toString();
                    this.loadIntervals()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getAsSwedishNumberString(number) {
                return number.toString().replace(".", ",");
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadPotDistribution() {
                this.loading++;
                try {
                    var result = await WageService.getPotDistribution()
                    this.potBaseSalary = result.PotSalary;
                    this.GLDSalaryIncrease = this.getAsSwedishNumberString(result.GLDSalaryIncrease);
                    this.GLDSalaryIncreaseProcentage = this.getAsSwedishNumberString(result.GLDSalaryIncreaseProcentage);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
               this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                valid: false,
                rules: ValidationService.rules(),
                salaryIntervals: [],
                potSalaryPerPoints: null,
                potBaseSalary: 0,
                startPoint: null,
                endPoint: null,
                baseSalary: null,
                calculationType: "0",
                positions: [],
                GLDSalaryIncrease: "0",
                GLDSalaryIncreaseProcentage:"0",
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            
        },
        mounted() {
            this.loadPotDistribution();
            this.getSalaryPart();
            this.getPositionsWithPoints();
            
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updatePotSalaryInterval, form, form2 }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
